import React, { useState, useEffect } from "react"
import { Col, Card, CardBody, CardTitle, Progress } from "reactstrap"
import axios from "axios"
import { DASHTOPCOMPLAINTS } from "helpers/url_helper"
import { Config } from "helpers/backend_helper"

const TopCategories = () => {
    const [topCatName, setTopCatName] = useState('Top category')
    const [topCatNo, setTopCatNo] = useState(0)
    const [topCats, setTopCats] = useState([])
    const [colors, setColors] = useState(['danger', 'warning', 'primary', 'success', 'warning','secondary'])

    useEffect(()=>{
        axios.get(DASHTOPCOMPLAINTS, Config).then((r)=>{
            if(r.data){
                if(r.data.length > 0){
                    setTopCatName(r.data[0].name)
                    setTopCatNo(r.data[0].complaints)
                    setTopCats(r.data)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])
  return (
    <React.Fragment>
    <Col xl="12">
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Top Complaints Categories</CardTitle>
          <div className="text-center">
            <div className="mb-4">
              <i className="bx bx-map-pin text-danger display-4" />
            </div>
            <h3>{topCatName}</h3>
            <p>{topCatNo}</p>
          </div>

          <div className="table-responsive mt-4">
            <table className="table align-middle table-nowrap">
              <tbody>
                {topCats.map((t,k)=>(
                    <tr key={k}>
                  <td style={{ width: "75%" }}>
                    <p className="mb-0">{t.name}</p>
                  </td>
                  <td style={{ width: "25%" }}>
                    <h5 className="mb-0">{t.complaints}</h5>
                  </td>
                  
                </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
      </Col>
    </React.Fragment>
  )
}

export default TopCategories
